var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.03448V14.6897C0 14.7811 0.0363299 14.8688 0.100998 14.9335C0.165665 14.9982 0.253374 15.0345 0.344828 15.0345H19.6552C19.7466 15.0345 19.8343 14.9982 19.899 14.9335C19.9637 14.8688 20 14.7811 20 14.6897V11.2686C20 11.058 19.9357 10.8525 19.8158 10.6794C19.6958 10.5063 19.5259 10.3739 19.3288 10.3L17.2414 9.51724L15.1892 4.82647C15.0817 4.58078 14.9049 4.37175 14.6805 4.22496C14.456 4.07818 14.1937 4 13.9255 4H1.03448C0.760121 4 0.496996 4.10899 0.302993 4.30299C0.10899 4.497 0 4.76012 0 5.03448Z",
    fill: "#F8C460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 15.0352H0.344828C0.253374 15.0352 0.165665 14.9988 0.100998 14.9342C0.0363293 14.8695 0 14.7818 0 14.6903V13.311H20V14.6903C20 14.7818 19.9637 14.8695 19.899 14.9342C19.8343 14.9988 19.7466 15.0352 19.6552 15.0352Z",
    fill: "#415E89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 5.72373V9.17201C12.4138 9.26346 12.4501 9.35117 12.5148 9.41584C12.5795 9.48051 12.6672 9.51684 12.7586 9.51684H17.2414L15.4311 5.37891H12.7586C12.6672 5.37891 12.5795 5.41524 12.5148 5.4799C12.4501 5.54457 12.4138 5.63228 12.4138 5.72373Z",
    fill: "#4DB6E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.3105H18.6207C18.5292 13.3105 18.4415 13.2742 18.3769 13.2095C18.3122 13.1449 18.2759 13.0572 18.2759 12.9657V12.2761C18.2759 12.1846 18.3122 12.0969 18.3769 12.0322C18.4415 11.9676 18.5292 11.9312 18.6207 11.9312H20V13.3105Z",
    fill: "#DFDFDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03442 5.03516H11.3793V5.72481H1.03442V5.03516Z",
    fill: "#F9A40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03442 9.17188H11.3793V9.86153H1.03442V9.17188Z",
    fill: "#F9A40F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1379 5.37891H14.8276V9.51684H14.1379V5.37891Z",
    fill: "#3BA5D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 16.4133C16.3151 16.4133 17.2414 15.487 17.2414 14.3444C17.2414 13.2017 16.3151 12.2754 15.1725 12.2754C14.0298 12.2754 13.1035 13.2017 13.1035 14.3444C13.1035 15.487 14.0298 16.4133 15.1725 16.4133Z",
    fill: "#34507B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13781 16.4133C5.28047 16.4133 6.20678 15.487 6.20678 14.3444C6.20678 13.2017 5.28047 12.2754 4.13781 12.2754C2.99515 12.2754 2.06885 13.2017 2.06885 14.3444C2.06885 15.487 2.99515 16.4133 4.13781 16.4133Z",
    fill: "#34507B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1723 15.0336C15.5532 15.0336 15.862 14.7248 15.862 14.344C15.862 13.9631 15.5532 13.6543 15.1723 13.6543C14.7914 13.6543 14.4827 13.9631 14.4827 14.344C14.4827 14.7248 14.7914 15.0336 15.1723 15.0336Z",
    fill: "#DFDFDD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1379 15.0336C4.51878 15.0336 4.82755 14.7248 4.82755 14.344C4.82755 13.9631 4.51878 13.6543 4.1379 13.6543C3.75701 13.6543 3.44824 13.9631 3.44824 14.344C3.44824 14.7248 3.75701 15.0336 4.1379 15.0336Z",
    fill: "#DFDFDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 10.5508H13.7931V11.2404H12.4138V10.5508Z",
    fill: "#FFC261"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5508H11.3793V11.2404H10V10.5508Z",
    fill: "#FFC261"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03457 13.3105H8.41618e-05V11.9312H1.03457C1.12602 11.9312 1.21373 11.9676 1.2784 12.0322C1.34306 12.0969 1.37939 12.1846 1.37939 12.2761V12.9657C1.37939 13.0572 1.34306 13.1449 1.2784 13.2095C1.21373 13.2742 1.12602 13.3105 1.03457 13.3105Z",
    fill: "#D65246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgvIcon);
export default __webpack_public_path__ + "static/media/LgvIcon.0f01249552a12ae3e23e6475e3ecebe6.svg";
export { ForwardRef as ReactComponent };